import { QueryClient } from "@tanstack/react-query";

import {
  computeOptimizations,
  OptimizationDto,
} from "#modules/optimizations/infra/computeOptimizations.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const optimizationsQuery = ({ quoteRequestId }: { quoteRequestId: string }) => ({
  queryKey: queryKeys.optimizations.byQuoteRequest(quoteRequestId),
  queryFn: () => computeOptimizations(quoteRequestId),
  staleTime: 0,
});

export const getOptimizationsQueryData = (
  queryClient: QueryClient,
  quoteRequestId: string,
): OptimizationDto[] | undefined => {
  return queryClient.getQueryData<OptimizationDto[]>(
    queryKeys.optimizations.byQuoteRequest(quoteRequestId),
  );
};

type OptimizationsQueryDataUpdater =
  | OptimizationDto[]
  | undefined
  | ((old: OptimizationDto[] | undefined) => OptimizationDto[] | undefined);

export const setOptimizationsQueryData = (
  queryClient: QueryClient,
  quoteRequestId: string,
  updater: OptimizationsQueryDataUpdater,
): OptimizationDto[] | undefined => {
  return queryClient.setQueryData<OptimizationDto[]>(
    queryKeys.optimizations.byQuoteRequest(quoteRequestId),
    updater,
  );
};
